module.exports = __webpack_public_path__ + "static/img/map.442cd135.jpg";